import React from 'react';

import { Trans } from 'react-i18next';

import BdsCircleIndicatorPictogram from '../../../../../../../../shared/components/v3/BdsCircleIndicator/BdsCircleIndicatorPictogram/BdsCircleIndicatorPictogram';
import BdsLabelPill from '../../../../../../../../shared/components/v3/BdsLabelPill/BdsLabelPill';
import BdsIconButton from '../../../../../../../../shared/components/v3/Buttons/BdsIconButton/BdsIconButton';
import BdsCardContainer from '../../../../../../../../shared/components/v3/Cards/BdsCardContainer/BdsCardContainer';
import { NORTH_EAST_ARROW } from '../../../../../../../../shared/constants/images';
import { IActionCard } from '../../../../../../../../shared/interfaces/actionCard';

import './ActionCard.scss';

const ActionCard = ({ value, description, action, insight, leadingIcon, extraPadding }: IActionCard) => {
  return (
    <BdsCardContainer
      borderRadiusSize="radius-l"
      paddingSize="padding-l"
      className="action-card w-full flex flex-column justify-center items-start"
      onClick={action}
      type="outline-subtle"
      withMinWidth={false}
    >
      <div className="top-content w-full flex flex-row justify-between items-center">
        <BdsCircleIndicatorPictogram
          circleIndicatorSize="m"
          pictogram={{ component: leadingIcon }}
          className={`leading-icon ${extraPadding ? 'extra-padding' : ''}`}
        />
        {action && <BdsIconButton action={action} icon={NORTH_EAST_ARROW} size="lg" variant="inverse" />}
      </div>
      <div className="bottom-content flex flex-column items-start">
        <h3 className="value">{value}</h3>
        <div className="description">{<Trans i18nKey={description} components={{ br: <br /> }} />}</div>
        {insight && <BdsLabelPill iconLeft={NORTH_EAST_ARROW} className="label-pill" text={insight} variant="fill" />}
      </div>
    </BdsCardContainer>
  );
};

export default ActionCard;
